// Module
var code = "<template>\n    <slot></slot>\n</template>\n";
// Exports
export default code;